import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _UBLInvoice } from '../../../../core/services/dataBean/EntityCatalog';



interface Props {

    idSelector: number;
    onChange: any;
    label?: string;
}

export const SoftwareDispatcherByEnvironmentType = ({ idSelector, onChange, label }: Props) => {

    const soft = useDataBean(_UBLInvoice)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector)
        }
    }, [])


    useEffect(() => {
        getLista();
    }, [])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        soft.instance.getUBLSoftwareDispatcherByEnvironmentType(null).then(
            (resp) => {
                const data =
                    resp;

                setLista(data); // 👈 ya NO es arreglo
            }
        );
    };

    return (
        <>
            <label>{label ?? "Facturador"}</label>
            <select
                className="form-select"
                value={id}
                onChange={(e) => setValue(e.target.value)}
            >
                <option value={null}>...</option>

                {lista && (
                    <option value={lista.IDUBLSoftwareDispatcher}>
                        {lista.EnvironmentTypeName}
                    </option>
                )}
            </select>
        </>
    )
}